import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { NavLink } from "react-router-dom"
import shop from "shop/shop"
import app from "../../app.controller";

const NavigationCategories = ( { categories } ) => {
  const addLink = function ( category, level ) {
    let children = _.map( category.children, subcat => addLink( subcat, level + 1 ) )
    let parents = getParents( category )
    let parentSegment = (category.parent) ? `/${parents.join( "/" )}` : ""
    let to = `/collection${parentSegment}/${category.map_id}/`
    // if ( !category.active ) return <div key={category.map_id} className={"black-40"}>[OFF] {category.desc.short_des}</div>
    if ( !category.active ) return null
    if ( category.isHidden ) return null
    return (<div key={category.map_id}>
      <NavLink
        className={`level-${level} cat-${category.map_id}`}
        // activeClassName="active"
        onClick={app.sidebarLeft.close.dispatch}
        to={to}>{category.desc.short_des}
        {/*<span className="red">({category.sort})</span>*/}
      </NavLink>
      {children.length >= 1 && <div className={`sub sub-${level}`}>{children}</div>}
    </div>)
  }
  let cats = _.map( categories, cat => addLink( cat, 0 ) )
  return (
    <div>
      {cats}
    </div>
  )
}

NavigationCategories.propTypes = {
  categories: PropTypes.any
}

const getParents = ( category ) => {
  let ttl = 10
  let parents = []
  while (category && category.parent && ttl--) {
    parents.push( category.parent )
    category = shop.categoriesById.get( category.parent )
  }
  return parents.reverse()
}


export default NavigationCategories


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationCategories.js